import store from '@/store'

export default function formatClientLink(link) {
  if (!link) return null

  if (link.startsWith('http')) {
    return link
  }

  if (!link.startsWith('/')) {
    link = '/' + link
  }

  if (store.state.defaultLocale === store.state.currentLocale) {
    return link
  }

  return `/${store.state.currentLocale}${link}`
}
